export function aggregateItemResponses(items, itemResponses) {
  if (!items) {
    return {
      xAxisData: [],
      scoreData: [],
      timeData: [],
      //responseData:[],
    };
  }

  let aggregateDict = {};
  let xAxisData = [];
  let itemList = [];

  items.forEach((itm, i) => {
    let item_id = itm._id;
    let itm_repl = ''.concat(
      "<a href='https://author.learnosity.com/org/473/item/editornew/?ref=",
      item_id,
      "'>Q",
      i + 1,
      '</a>',
    );
    itemList.push(item_id);
    xAxisData.push(itm_repl);
    aggregateDict[item_id] = {
      score: {},
      max_score: {},
      time: {},
      avg_attempts: {},
      accuracy: {},
      questions: {},
      _id: {},
      num_widgets: itm.definition.widgets.length,
      responses: {},
    };
    itm.questions.forEach(ques => {
      aggregateDict[item_id]['questions'][ques.reference] = {
        score: {},
        max_score: {},
      };
    });
  });
  itemResponses.sort(function(a, b) {
    return a.responses[0].dt_score_updated.localeCompare(b.responses[0].dt_score_updated);
  });
  itemResponses.forEach(itm_res => {
    if (aggregateDict[itm_res.reference]['score'][itm_res.user_id] === undefined) {
      aggregateDict[itm_res.reference]['score'][itm_res.user_id] = itm_res.score;
      aggregateDict[itm_res.reference]['time'][itm_res.user_id] = itm_res.time;
      aggregateDict[itm_res.reference]['max_score'][itm_res.user_id] = itm_res.max_score;
      aggregateDict[itm_res.reference]['accuracy'][itm_res.user_id] =
        itm_res.score / itm_res.max_score;
      aggregateDict[itm_res.reference]['avg_attempts'][itm_res.user_id] =
        itm_res.total_attempts / itm_res.num_attempted;
      aggregateDict[itm_res.reference]['_id'][itm_res.user_id] = itm_res._id;
    }
    itm_res.responses.forEach(res => {
      if (!res) {
        aggregateDict[itm_res.reference]['questions'][res.question_reference]['score'][
          itm_res.user_id
        ] = res.score;
        aggregateDict[itm_res.reference]['questions'][res.question_reference][
          'max_score'
        ][itm_res.user_id] = res.max_score;
        aggregateDict[itm_res.reference]['questions'][res.question_reference][
          'num_attempts'
        ][itm_res.user_id] = res.response.metadata.attempts;
      }
    });
  });

  return { aggregateDict, itemList, xAxisData };
}

export const q25 = arr => quantile(arr, 0.25);

export const q50 = arr => quantile(arr, 0.5);

export const q75 = arr => quantile(arr, 0.75);

const quantile = (arr, q) => {
  const sorted = asc(arr);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
};
function asc(arr) {
  return arr.sort(function(a, b) {
    return a - b;
  });
}
// const mean =(arr) => {
//   let total = 0;
//   for (let i = 0; i < arr.length; i++) {
//     total += arr[i];
//   }
//   let avg = total / arr.length;
// };
